export { default as DocumentReportSolidIcon } from './DocumentReportSolidIcon';
